import { render, staticRenderFns } from "./opt_addres.vue?vue&type=template&id=117696db&scoped=true"
import script from "./opt_addres.vue?vue&type=script&lang=js"
export * from "./opt_addres.vue?vue&type=script&lang=js"
import style0 from "./opt_addres.vue?vue&type=style&index=0&id=117696db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117696db",
  null
  
)

export default component.exports